import * as flexsearch from "flexsearch";

import { search as searchApi } from "apis-v2/callables";
import { IWorkspaceResourcePresentation, WorkspaceResourceType } from "common/interfaces";
import { publicWorkspaces } from "js/config";

import { BasePresentationsPaneController, BasePresentationsPaneControllerState } from "./BasePresentationsPaneController";

export type StarterTemplatesPaneControllerState = BasePresentationsPaneControllerState<IWorkspaceResourcePresentation>;

class StarterTemplatesPaneController extends BasePresentationsPaneController<IWorkspaceResourcePresentation> {
    protected get _resourceTypes(): WorkspaceResourceType[] {
        return [WorkspaceResourceType.PRESENTATION];
    }

    protected get _batchSize() {
        return 10;
    }

    // Catalog workspace is read by non-members; private-workspace channel auth would 403.
    protected get _subscribeToWorkspaceUpdates() {
        return false;
    }

    protected async _fetchSearchIndex({ locale, workspaceId }: { locale: string, workspaceId: string }): Promise<{ indexConfig: flexsearch.DocumentOptions<any>, indexFileReadUrl: string }> {
        return searchApi.getPresentationsSearchIndex({ workspaceId, locale });
    }

    public async inititialize(props: Omit<Parameters<BasePresentationsPaneController<IWorkspaceResourcePresentation>["initialize"]>[0], "workspaceId">) {
        const presentationTemplatesWorkspaceId = publicWorkspaces.presentationTemplates;

        await super.initialize({
            ...props,
            workspaceId: presentationTemplatesWorkspaceId
        });
    }
}

const starterTemplatesPaneController = new StarterTemplatesPaneController();
export default starterTemplatesPaneController;
